module.exports = __webpack_public_path__ + "img/consumer-month.4c9d6bd.png";